import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';
import card from 'src/common/media/CreditDebitGrey.svg';

export const styles = makeStyles(theme => ({
  tenderGroupTitleContainer: {
    height: '8.8vh',
  },
  tenderGroupTitleHeader: {
    color: themeColor.modalTitle,
    fontSize: vh(4.18),
    fontWeight: 500,
  },
  tenderGroupTitleBar: {
    color: themeColor.infoMain,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    width: '50px',
  },
  preSwipedTender: {
    backgroundImage: `url(${card})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '12px',
    backgroundPosition: '95% 90%',
  },
  tenderingContainer: {
    backgroundColor: themeColor.lightBackground,
  },
  contentContainer: {
    flex: '1 1 0',
    padding: '4.25vh 1.30vw 1.85vh 0.65vw',
  },
  addLeftPadding: {
    paddingLeft: '1vw',
  },
  flexStart: {
    alignContent: 'flex-start',
  },
  positionRelative: {
    position: 'relative',
  },
  actionButtons: {
    width: '12.3vw',
  },
  tenderButtonSelected: {
    border: `0.3em solid ${theme.palette.secondary.main}!important`,
    color: themeColor.almostblack,
    '&.Mui-disabled': {
      color: `${themeColor.almostblack} !important`,
    },
  },
  tenderButton: {
    marginBottom: '1.5vh',
    width: '100%',
    height: 'auto',
    '@media (max-width: 1024px) and (max-height: 768px)': {
      marginBottom: '1.1vh',
    },
  },
  tenderButtonSmallForm: {
    marginBottom: '1.5vh',
    maxWidth: '10vw',
    overflow: 'hidden',
    display: 'inline-block',
    whiteSpace: 'normal',
    textOverflow: 'ellipsis',
    marginRight: '1vw',
    '@media (max-width: 1024px) and (max-height: 768px)': {
      marginBottom: '1.1vh',
      width: '10vw',
      height: '1vh',
      padding: 0,
    },
  },
  tenderButtons: {
    maxHeight: '90%',
  },
  middleContainer: {
    flex: '1 1 0px',
    minHeight: '100%',
  },
  middleLabel: {
    fontSize: vh(3.125),
    fontWeight: 400,
    paddingBottom: '2vh',
  },
  middleIcon: {
    width: '8%',
  },
  exitButton: {
    lineHeight: '1.14',
    letterSpacing: '0.05rem',
    fontSize: vh(2.08),
    '&:hover': {
      boxShadow: 'none',
    },
  },
  textAlignCenter: {
    textAlign: 'center',
    height: 'fit-content',
    width: '100%',
  },
  total: {
    fontSize: vh(3.125),
    fontWeight: 500,
    letterSpacing: '0.02rem',
    paddingTop: '0.5vh',
    textAlign: 'center',
    '&.textAlignLeft': {
      textAlign: 'left',
    },
    '&.textAlignRight': {
      textAlign: 'right',
    },
  },
  totalLabel: {
    fontSize: vh(1.8),
    color: theme.palette.info.dark,
    fontWeight: 500,
    paddingTop: '1vh',
    '&.textAlignLeft': {
      textAlign: 'left',
    },
    '&.textAlignRight': {
      textAlign: 'right',
    },
  },
  customTopLabel: {
    paddingBottom: '1.302vh',
  },
  exit: {
    fontSize: vh(2.35),
    marginLeft: '50%',
    transform: 'translateX(-50%)',
  },
  paddingTop: {
    paddingTop: '4vh',
  },
  keypadGridItem: {
    flex: '0 0 0',
    paddingTop: '4.255vh',
    paddingRight: '1.06vw',
    paddingBottom: '1.82vh',
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
  },
  labelText: {
    fontWeight: 500,
    letterSpacing: '0.1vw',
    fontSize: vh(1.6),
    '@media (max-width: 1024px) and (max-height: 576px)': {
      fontSize: vh(1.45),
    },
    lineHeight: '2.08vh',
  },
  navButtons: {
    marginTop: 'auto',
    maxHeight: '10%',
  },
  processTenderContainer: {
    width: '0',
    backgroundColor: themeColor.lightBackground,
  },
  processTenderTopRow: {
    marginLeft: '2%',
    marginRight: '2%',
    marginTop: '1%',
  },
  singleFieldTopMargin: {
    marginTop: vh(8),
  },
  promptText: {
    '@media (max-width: 1280px) and (max-height: 768px)': {
      fontSize: vh(3.125),
    },
  },
  customTabs: {
    margin: '2vh',
    marginBottom: '1vh',
    '@media (max-width: 1600px) and (max-height: 1200px)': {
      margin: '1vh',
      marginBottom: 0,
    },

    '& >*:first-child': {
      boxShadow: `8px 0px 8px 1px ${themeColor.lightBackground},
        -5px 10px 5px 2px ${themeColor.lightBackground},
        -5px -10px 5px 2px ${themeColor.lightBackground}`,
      opacity: 100,
      zIndex: 999,
      marginLeft: '1vw',
      width: '2vw',
      minWidth: '2vw',
    },

    '& >*:last-child': {
      boxShadow: `-8px 0px 8px 1px ${themeColor.lightBackground},
        -5px 10px 5px 2px ${themeColor.lightBackground},
        -5px -10px 5px 2px ${themeColor.lightBackground}`,
      opacity: 100,
      zIndex: 999,
      marginRight: '1vw',
      width: '2vw',
      minWidth: '2vw',
    },
  },
  allTabsContainer: {
    display: 'block',
    '& >*:first-child': {
      marginLeft: '1vw',
    },
    '& >*:last-child': {
      marginRight: '1vw',
    },
  },
  scrollButton: {
    minWidth: '4.09vw',
    height: '7.09vh',
    '&.Mui-disabled': {
      color: themeColor.subheaderLight,
    },
  },
  secondLevelTab: {
    backgroundColor: themeColor.white,
    marginRight: 10,
    borderRadius: 2,
    border: `1px solid ${themeColor.secondaryLight}`,
    height: '7.29vh',
    color: theme.palette.info.dark,
    letterSpacing: '0.02vw',
    lineHeight: '2.6vh',
    width: 'auto',
    minWidth: '10vw',
    maxWidth: '15vw',
    padding: '0 1.5vw',
    '& span': {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      fontWeight: 500,
      letterSpacing: '0.1vw',
      fontSize: vh(1.6),
      '@media (max-width: 1024px) and (max-height: 576px)': {
        fontSize: vh(1.45),
      },
      lineHeight: '2.08vh',
      hyphens: 'auto',
      width: '100%',
      overflowWrap: 'break-word',
      textTransform: 'uppercase',
      color: themeColor.defaultTextColor,
    },
    '&.Mui-selected': {
      border: `solid ${theme?.configColors?.secondaryColor || themeColor.secondaryMain}`,
      color: themeColor.defaultTextColor,
    },
    '&.Mui-disabled': {
      opacity: 0.4,
    },
  },
  fitHeight: {
    height: 'fit-content',
  },
  flexSmallForm: {
    flex: '1',
  },
  keypadToggleButtonLeftHand: {
    position: 'absolute',
    left: 0,
  },
}));
